<template>
    <div>
        <div v-if="!isDemoMode">
            <nav
                class="navbar navbar-light bg-light justify-content-between"
                v-show="isNormalPortalMode"
            >
                <div class="row">
                    <!-- Search field -->
                    <search-box
                        @input="$_onInputSearch"
                        :info="'Filter op naam/omschrijving...'"
                        class="div-search"
                        :autofocus="true"
                    >
                    </search-box>
                    <!-- Sort field -->
                    <div class="form-group col-md-3 div-sort">
                        <label
                            id="lblSortOrder"
                            for="slcSortOrder"
                            class="d-none d-md-block"
                            >Sorteer op:</label
                        >
                        <b-form-select
                            :id="`slcSortOrder`"
                            class="form-control input-sm"
                            v-model="sort"
                            :options="
                                $_convertToValueTextPair(
                                    this.sortoptions,
                                    'code',
                                    'description'
                                )
                            "
                        >
                        </b-form-select>
                    </div>
                </div>
            </nav>
            <div
                v-for="portalThemeGroup in $_filteredPortalThemeGroups()"
                :key="portalThemeGroup"
            >
                <!-- Only show header when there are PortalThemeGroups -->
                <h2 v-if="$_hasPortalThemeGroups()" class="mb-0 ml-3">
                    {{ portalThemeGroup }}
                </h2>
                <div class="container-fluid container-cards">
                    <div class="row mt-3" id="webThemeCards">
                        <b-card
                            no-body
                            footer-tag="footer"
                            class="mx-2 mb-3"
                            v-for="t in $_filteredByPortalThemeGroup(
                                portalThemeGroup
                            )"
                            :key="t.id"
                        >
                            <a
                                :href="t.url"
                                target="_blank"
                                v-ng-usage:click="{
                                    name: 'portalOpenWindow',
                                    themeId: t.id
                                }"
                            >
                                <div
                                    v-if="!t.portalImage"
                                    class="center-cropped card-img-top"
                                    :style="
                                        $_getStyleCard(
                                            '/img/portal_example.png'
                                        )
                                    "
                                ></div>
                                <div
                                    v-if="t.portalImage"
                                    class="center-cropped card-img-top"
                                    :style="$_getStyleCard(t.portalImage)"
                                ></div>
                            </a>
                            <b-card-body
                                class="theme-card"
                                v-ng-usage:click="{
                                    name: 'portalOpenWindow',
                                    themeId: t.id
                                }"
                                @click="$_openWindow(t.url)"
                            >
                                <h5 class="card-title" id="themeName">
                                    {{ t.alias }}
                                </h5>
                                <div
                                    class="card-description"
                                    id="themeDescription"
                                >
                                    {{ t.description }}
                                </div>
                            </b-card-body>
                            <template v-slot:footer v-if="isNormalPortalMode">
                                <small class="text-muted">
                                    <a
                                        v-ng-usage:click="{
                                            name: 'portalOpenInfoBar',
                                            themeId: t.id
                                        }"
                                        href="#"
                                        @click="$_openInfobar($event, t)"
                                        >{{ $t('labelPortalInfoBarInfo') }}</a
                                    >
                                </small>
                            </template>
                        </b-card>
                    </div>
                </div>
            </div>
            <div class="infobar shadow" :class="$_getClassInfobar">
                <div class="infobar-title infobar-width">
                    <h5>
                        <span
                            class="fas fa-angle-double-right closebtn"
                            v-ng-usage:click="{
                                name: 'portalCloseInfobar'
                            }"
                            @click="$_closeInfobar()"
                            title="Sluit venster"
                        ></span>
                        {{ info.title }}
                    </h5>
                    <div class="card-img-top d-flex align-items-top bg-light">
                        <div class="m-3">
                            <div
                                class="infobar-image center-cropped"
                                :style="$_getStyleCard(info.portalImage)"
                            ></div>
                        </div>
                        <p class="col p-0 my-3 mr-3 infoDescription">
                            {{ $_infoDescription(info) }}
                        </p>
                    </div>
                </div>
                <div class="infobar-content mt-2">
                    <div
                        v-if="this.info.layers"
                        class="infobar-layer-info infobar-width pt-0"
                    >
                        <div v-for="layer in this.info.layers" :key="layer.id">
                            <b-card :title="layer.title" class="infocard mb-2">
                                <b-card-text
                                    class="infoDescription"
                                    v-if="layer.description"
                                    >{{ layer.description }}</b-card-text
                                >
                                <div v-if="layer.keyWords">
                                    <b-card-text class="infobar-label">
                                        {{ $t('labelThemeLayerKeywords') }}:
                                        <p>{{ layer.keyWords }}</p>
                                    </b-card-text>
                                </div>
                                <div v-if="layer.mapTerms">
                                    <b-card-text class="infobar-label">
                                        {{ $t('labelCopyright_Reference') }}:
                                        <p>{{ layer.mapTerms }}</p></b-card-text
                                    >
                                </div>
                                <b-card-text class="infobar-label"
                                    >{{ $t('labelService') }} ({{
                                        layer.serviceType
                                    }}):
                                    <p>
                                        {{ $_layerUrl(layer) }}
                                        <img
                                            class="copy-button"
                                            src="~@/assets/imported-icons/ic_fluent_copy_20_regular.svg"
                                            v-ng-usage:click="{
                                                name: 'portalCopyToClipboard'
                                            }"
                                            @click="$_copyToClipboard(layer)"
                                            :alt="$t('labelCopyServiceUrl')"
                                            :title="$t('labelCopyServiceUrl')"
                                        />
                                    </p>
                                </b-card-text>
                                <b-card-text class="infobar-label"
                                    >{{ $t('labelLayerName') }}:
                                    <p>
                                        {{ layer.layerName }}
                                    </p></b-card-text
                                >
                                <div class="d-flex">
                                    <layer-metadata
                                        v-if="
                                            layer.metadataUrl &&
                                            layer.infoLinkType ===
                                                INFO_LINK_TYPE.METADATA
                                        "
                                        :layer="layer"
                                        type="button"
                                    />
                                    <layer-info
                                        v-if="
                                            layer.infoUrl &&
                                            layer.infoLinkType ===
                                                INFO_LINK_TYPE.EXTERNAL
                                        "
                                        :layer="layer"
                                        type="button"
                                    />
                                    <div
                                        v-if="
                                            layer.wfsUrl &&
                                            layer.serviceType == 'WFS' &&
                                            layer.outputFormats
                                        "
                                    >
                                        <b-dropdown
                                            id="downloadDropdown"
                                            variant="primary"
                                        >
                                            <template #button-content>
                                                {{ $t('labelDownloadData') }}
                                                <b-spinner
                                                    :id="$_spinnerId(layer)"
                                                    small
                                                    style="
                                                        align-self: center;
                                                        display: none;
                                                    "
                                                    label="Loading"
                                                />
                                            </template>
                                            <b-dropdown-item
                                                v-for="format in layer.outputFormats"
                                                :key="format"
                                                v-ng-usage:click="{
                                                    name: 'portalDownload',
                                                    format: format,
                                                    layer: layer.layerName
                                                }"
                                                @click.prevent="
                                                    $_download(format, layer)
                                                "
                                                >{{ format }}
                                            </b-dropdown-item>
                                        </b-dropdown>
                                    </div>
                                </div>
                            </b-card>
                        </div>
                    </div>
                </div>
            </div>
        </div>
        <DemoComponent
            v-if="isDemoMode"
            :webthemes="sortedRecords"
            :organization="organization"
            :group="group"
        >
        </DemoComponent>
    </div>
</template>

<script>
    import { PORTAL_MODE, SORT_WEBTHEME, INFO_LINK_TYPE } from '../../constants';
    import {
        convertToValueTextPair,
        truncateString,
        getWebThemePortalUrl
    } from '../../services/utilities';
    import { orderBy } from 'lodash';
    import SearchBox from '../../components/SearchBox.vue';
    import refcodeMixin from '../../components/Mixins/Refcodes/refcodeMixin.vue';
    import DemoComponent from './Demo.vue';
    import axios from 'axios';
    import LayerMetadata from '../../components/geo/panels/layers/LayerMetadata';
    import LayerInfo from '../../components/geo/panels/layers/LayerInfo';
    import modalMixin from '../../components/Mixins/ModalMixin.vue';

    export default {
        mixins: [modalMixin, refcodeMixin],

        components: {
            'search-box': SearchBox,
            'layer-metadata': LayerMetadata,
            'layer-info': LayerInfo,
            DemoComponent
        },

        data() {
            return {
                INFO_LINK_TYPE: INFO_LINK_TYPE,
                parameters: null,
                organization: null,
                group: null,
                count: null,
                mode: null,
                sort: null,
                sortoptions: [],
                webthemes: [],
                info: {},
                slide: 'in',
                searchText: '',
                outputformat: null
            };
        },

        computed: {
            sortedRecords() {
                return this.$_sortWebThemes(this.webthemes);
            },

            isNormalPortalMode() {
                return this.mode !== PORTAL_MODE.TOPPAGE;
            },

            isDemoMode() {
                return this.mode === PORTAL_MODE.DEMO;
            },

            $_getClassInfobar() {
                return `infobar-slide-${this.slide}`;
            },
            $_filteredRecords() {
                // return webthemes filtered by user search criteria
                // First, filter records on name and description
                let records = this.webthemes;
                if (this.searchText && this.searchText.length > 0) {
                    const tokens = this.searchText.toLowerCase();

                    records = records.filter((record) => {
                        return (
                            record.name.toLowerCase().includes(tokens) ||
                            (record.description &&
                                record.description
                                    .toLowerCase()
                                    .includes(tokens)) ||
                            (record.keywords &&
                                record.keywords.toLowerCase().includes(tokens))
                        );
                    });
                }

                // Then sort webthemes
                return this.$_sortWebThemes(records);
            }
        },

        mounted() {
            this.$_initRefCodes();
            this.$_readParameters();
            this.$_initializePortal();
        },

        methods: {
            $_filteredByPortalThemeGroup(filter) {
                // Return webthemes for a given portalThemeGroup (after they have been filtered by user search)
                /// filter using == to match falsy values (null and "").
                let records = this.$_filteredRecords.filter(
                    (w) => w.portalThemeGroup == filter
                );
                return records;
            },

            $_filteredPortalThemeGroups() {
                // Return available portalThemeGroup values given a filtered list of webthemes.
                let uniquePortalThemeGroups = new Set(
                    this.$_filteredRecords.map((f) => f.portalThemeGroup)
                );

                // if the value "other" is in the list of portalThemeGroups
                // remove it, sort the list and add it to the end.
                const hasOther = uniquePortalThemeGroups.has(this.$t('labelOther'));

                if (hasOther) {
                    uniquePortalThemeGroups.delete(this.$t('labelOther'));
                }

                let sortedPortalThemeGroups = Array.from(
                    uniquePortalThemeGroups
                ).sort();

                if (hasOther) {
                    sortedPortalThemeGroups.push(this.$t('labelOther'));
                }

                return sortedPortalThemeGroups;
            },

            $_portalThemeGroups() {
                // Return all available portalThemeGroups given a list of webthemes.
                let uniquePortalThemeGroups = new Set(
                    this.webthemes.map((f) => f.portalThemeGroup)
                );

                return Array.from(uniquePortalThemeGroups).sort();
            },

            $_hasPortalThemeGroups() {
                // Are there any portalThemeGroups other than null or empty. In this case length > 0
                return this.$_portalThemeGroups().filter((a) => a).length > 0;
            },

            $_convertToValueTextPair(inputArray, key, value) {
                return convertToValueTextPair(inputArray, key, value);
            },

            $_initRefCodes() {
                // Get options for dropdownlist
                this.getRefCodes(SORT_WEBTHEME.KEY).then((result) => {
                    this.sortoptions = result.data;
                });
            },

            $_readParameters() {
                this.parameters = this.$route.query;
                this.organization = this.parameters.organization;
                this.group = this.parameters.group;
                this.count = this.parameters.count;
                this.mode = this.parameters.mode;
                this.sort = this.parameters.sort;

                this.$store.commit(
                    'PORTAL_SET_ORGANIZATIONNAME',
                    this.organization
                );
                if (
                    !this.sort ||
                    (this.sort !== SORT_WEBTHEME.POPULARITY &&
                        this.sort !== SORT_WEBTHEME.TITLE)
                ) {
                    this.sort = SORT_WEBTHEME.POPULARITY;
                }
            },

            async $_initializePortal() {
                if (!this.organization) {
                    // Go to portal no parameter error page
                    this.$router.push('/error/portal_no_parameter');
                }
                const errorMessageData = {
                    message: 'Ophalen van laag informatie is mislukt.',
                    variant: 'danger',
                    title: 'Informatie ophalen mislukt',
                    autoHideDelay: 10000
                };

                await this.$store
                    .dispatch('useApiData', {
                        name: 'WebCheckOrganizationName',
                        parameters: { organizationName: this.organization }
                    })
                    .then(
                        async (result) => {
                            await this.$store
                                .dispatch('useApiData', {
                                    name: 'WebGetOrganizationProperties',
                                    parameters: {
                                        organizationName: this.organization
                                    }
                                })
                                .then(
                                    async (resultProperties) => {
                                        if (
                                            resultProperties !== null &&
                                            resultProperties.data !== null &&
                                            resultProperties.data.licenses.indexOf(
                                                'Portal'
                                            ) > -1
                                        ) {
                                            await this.$store
                                                .dispatch('useApiData', {
                                                    name: 'WebGetAllByOrganizationName',
                                                    parameters: {
                                                        organizationName:
                                                            this.organization,
                                                        group: this.group
                                                    }
                                                })
                                                .then(
                                                    (resultWebThemes) => {
                                                        if (
                                                            resultWebThemes !==
                                                                null &&
                                                            resultWebThemes.data !==
                                                                null &&
                                                            resultWebThemes.data
                                                                .length > 0
                                                        ) {
                                                            // Extend webthemes
                                                            this.webthemes =
                                                                this.$_extendWebThemes(
                                                                    resultWebThemes.data
                                                                );
                                                        } else {
                                                            // Go to portal no webthemes error page
                                                            this.$router.push(
                                                                '/error/portal_no_webthemes'
                                                            );
                                                        }
                                                    },
                                                    (error) => {
                                                        console.log(
                                                            error.response.data
                                                                ? error.response
                                                                      .data.message
                                                                : error
                                                        );
                                                        // Go to portal webthemes error page
                                                        this.$router.push(
                                                            '/error/portal_error_webthemes'
                                                        );
                                                    }
                                                )
                                                .catch((error) => {
                                                    errorMessageData.message =
                                                        error.response
                                                            ? error.response.data
                                                                  .message
                                                            : error.message;
                                                    console.log(errorMessageData);
                                                });
                                        } else {
                                            // Go to portal no license error page
                                            this.$router.push(
                                                '/error/portal_no_license'
                                            );
                                        }
                                    },
                                    (error) => {
                                        console.log(error.message);
                                        // Go to portal licenses error page
                                        this.$router.push(
                                            '/error/portal_error_licenses'
                                        );
                                    }
                                )
                                .catch((error) => {
                                    error.message = `Geen licentie gevonden voor organisatie ${this.organization}.`;
                                    console.log(error);
                                });
                        },
                        () => {
                            // Go to portal incorrect organization error page
                            this.$router.push(
                                '/error/portal_incorrect_organization'
                            );
                        }
                    )
                    .catch((error) => {
                        error.message = `Organisatie ${this.organization} niet gevonden.`;
                        console.log(error);
                    });
            },

            $_extendWebThemes(webthemes) {
                // Set correct Url
                for (const webtheme of webthemes) {
                    webtheme.url = getWebThemePortalUrl(webtheme);
                }

                // Get top records
                if (
                    this.count &&
                    this.mode === PORTAL_MODE.TOPPAGE &&
                    webthemes &&
                    webthemes.length > 0
                ) {
                    // First sort by popularity desc
                    webthemes.sort(function (a, b) {
                        return parseFloat(b.number) - parseFloat(a.number);
                    });
                    webthemes = webthemes.slice(0, this.count);
                }

                // Is there at least 1 webtheme with a non null portalthemegroup value?
                // Then fill empty portalthemegroup values with "other"
                let uniquePortalThemeGroups = new Set(
                    webthemes.map((f) => f.portalThemeGroup)
                );

                let portalThemeGroups = Array.from(uniquePortalThemeGroups).sort();
                const portalThemeGroupsExist =
                    portalThemeGroups.filter((a) => a).length > 0;
                const emptyPortalThemeGroupsExist =
                    portalThemeGroups.filter((a) => !a).length > 0;

                if (portalThemeGroupsExist && emptyPortalThemeGroupsExist) {
                    webthemes
                        .filter(
                            (a) =>
                                a.portalThemeGroup == null ||
                                a.portalThemeGroup == ''
                        )
                        .forEach((a) => {
                            a.portalThemeGroup = this.$t('labelOther');
                        });
                }

                return webthemes;
            },

            $_getStyleCard(img) {
                return `background-image: url('${img}')`;
            },

            $_onInputSearch(searchText) {
                this.searchText = searchText;
            },

            $_sortWebThemes(webthemes) {
                if (this.sort === SORT_WEBTHEME.POPULARITY) {
                    return orderBy(webthemes, 'number', 'desc');
                } else {
                    return orderBy(webthemes, [(o) => o.name.toLowerCase()], 'asc');
                }
            },

            $_openWindow(src) {
                window.open(src, '_blank');
            },

            $_openInfobar(event, webtheme) {
                event.preventDefault();

                if (this.slide === 'out' && this.info.id === webtheme.id) {
                    this.$_closeInfobar();
                    return;
                }

                let url = '/img/portal_example.png';

                if (webtheme.portalImage) {
                    url = webtheme.portalImage;
                }

                this.info = {
                    id: webtheme.id,
                    title: webtheme.name,
                    description: webtheme.description,
                    layers: webtheme.layers,
                    portalImage: url
                };

                this.loading = new Map();
                this.info.layers.forEach((layer) => this.loading.set(layer, false));

                this.slide = 'out';
            },

            $_closeInfobar() {
                this.slide = 'in';
            },

            $_extension(outputformat) {
                if (outputformat.includes('gml')) {
                    return 'gml';
                }
                if (outputformat.includes('xml')) {
                    return 'xml';
                }
                if (outputformat.includes('kml')) {
                    return 'kml';
                }
                if (outputformat.includes('json')) {
                    return 'json';
                }
                if (outputformat.includes('csv')) {
                    return 'csv';
                }
                if (outputformat.includes('zip')) {
                    return 'zip';
                }
                return 'txt';
            },

            $_owsVersion(versie) {
                return `${versie.toFixed(1)}.0`;
            },

            $_spinnerId(layer) {
                return layer.layerName + layer.id;
            },

            $_download(format, layer) {
                const spinnerId = this.$_spinnerId(layer);
                document.getElementById(spinnerId).style.display = 'inline-block';
                const Url = new URL(layer.wfsUrl);
                const extension = this.$_extension(format.toLowerCase());
                Url.searchParams.append('request', 'GetFeature');
                Url.searchParams.append('service', 'WFS');
                Url.searchParams.append(
                    'version',
                    this.$_owsVersion(layer.wfsVersion)
                );
                Url.searchParams.append('outputFormat', format);
                Url.searchParams.append('typeName', layer.layerName);

                axios({
                    url: Url,
                    method: 'GET',
                    responseType: 'blob'
                }).then((res) => {
                    let FILE = window.URL.createObjectURL(new Blob([res.data]));
                    let docUrl = document.createElement('a');
                    docUrl.href = FILE;
                    docUrl.setAttribute(
                        'download',
                        `${layer.layerName}.${extension}`
                    );
                    docUrl.setAttribute('href', FILE);
                    document.body.appendChild(docUrl);
                    docUrl.click();
                    document.body.removeChild(docUrl);
                    document.getElementById(spinnerId).style.display = 'none';
                });
            },

            $_layerUrl(layer) {
                switch (layer.serviceType) {
                    case 'WFS':
                        return layer.wfsUrl;
                    case 'WMS':
                        return layer.wmsUrl;
                    case 'WMTS':
                        return layer.wmtsUrl;
                    default:
                        return null;
                }
            },

            async $_copyToClipboard(layer) {
                const valueToCopy = this.$_layerUrl(layer);
                await navigator.clipboard.writeText(valueToCopy);
                const messageData = {
                    message: 'Service URL is gekopieerd.',
                    variant: 'info',
                    autoHideDelay: 4000
                };

                this.showToast(messageData);
            },

            $_infoDescription(info) {
                return truncateString(info.description, 250);
            }
        }
    };
</script>

<style scoped lang="scss">
.container-fluid {
    padding: 0px 0px 0px 0px;
    overflow: auto !important;
}

.container-cards {
    padding-right: 24px;
    padding-left: 24px;
}

.card {
    width: 12rem;

    & .card-body,
    & .card-footer {
        padding-left: 0.75rem;
    }
}

.infocard {
    width: 100%;
}

.theme-card {
    cursor: pointer;
}

.card-title {
    margin-top: 0;
    margin-bottom: 0;
    font-weight: bold;
}

/* Needed for search in description */
.card-description {
    display: none;
}

h5,
.h5 {
    font-size: 1.1rem;
    font-weight: bold;
}

.small,
small {
    font-size: 0.9rem;
}

.center-cropped {
    width: 100%;
    height: 140px;
    background-position: center;
    background-size: cover;
}

.form-group {
    margin-bottom: 0;
}

.div-search {
    -ms-flex: 0 0 350px;
    flex: 0 0 350px;
    max-width: initial;
}

.div-sort {
    display: flex;
}

.row {
    width: 100%;
}

#slcSortOrder {
    width: auto;
}

#lblSortOrder {
    padding-right: 10px;
    padding-top: 7px;
    white-space: nowrap;
}

.infobar {
    display: flex;
    flex-direction: column;
    height: 100%;
    width: 0;
    position: fixed;
    z-index: 10;
    top: 0;
    right: 0;
    background-color: #fff;
    transition: 0.5s;

    .infobar-content {
        flex: 1;
        overflow-y: auto;
        overflow-x: hidden;
    }
}

.infobar-label {
    font-weight: normal;
}

.card-text p {
    font-weight: bold;
}

h4.card-title {
    margin-bottom: 1rem;
}

.infobar a {
    padding: 8px 8px 8px 32px;
    text-decoration: none;
    font-size: 25px;
    color: #818181;
    display: block;
    transition: 0.3s;
}

.infobar a:hover {
    color: #f1f1f1;
}

.infobar .closebtn {
    padding: 8px 12px 8px 0px;
    top: 0;
    left: 0;
    cursor: pointer;
}

.infobar .infobar-title,
.infobar .infobar-layer-info {
    padding: 15px;
}

.infobar .infobar-title {
    border-bottom: 1px solid #d0cece;
    background-color: #f8f9fa;
}

.infobar .infobar-title h5 {
    margin: 0px;
}

.infobar-slide-in {
    width: 0px;
}

.infobar-slide-out,
.infobar-width {
    width: 600px;
}

.infobar-image {
    width: 120px;

    &.center-cropped {
        height: 120px;
    }
}

.infoDescription {
    white-space: pre-line;
}

.copy-button {
    vertical-align: middle;
    border: 1px solid rgba(0, 0, 0, 0.25);
    border-radius: 0.25em;
    padding: 0.1em;
    cursor: pointer;
}

/*-------------------------------------
    max-width : 767px
    ---------------------------------------*/
@media (max-width: 767px) {
    .infobar-slide-out,
    .infobar-width {
        width: 100%;
    }
}
</style>
